import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import './config/'
import './style/common.less'
import toast from './plugin/toast'
import plugin from './plugin/plugin'
import createModal from '@/plugin/create-modal'

Vue.use(plugin) // 引入
Vue.use(toast)
Vue.use(createModal)
Vue.config.productionTip = false

// 引入神策
var sensors = require('sa-sdk-javascript')
sensors.init({
  server_url: 'https://sensorsdata.xunyou.mobi/sa' + (['test-', 'localhost'].some(cur => { return location.hostname.includes(cur) }) ? '' : '?project=production'),
  is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect'
  },
  show_log: false // 控制台不展示上报
})
// sensors.quick('autoTrack') // 用于采集 $pageview 事件。
Vue.prototype.$sensors = sensors
new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
